<template>
  <div>

    <IndxHeads></IndxHeads>
    <section class="newBg"></section>
    <div class="w1024">

      <div class="d-flex space-between align-center" style="margin-bottom: 30px;">
        <div>
          <h1 class="text-left pt-50 " style="font-size: 30px;">新闻资讯 </h1>
          <p class="line-block"></p>
          <p class="text-left fs-14  color-9 text-uppercase">News and Information</p>
        </div>
        <div class="d-flex moreCom" style="margin-top: 30px;">

          <div> <a href="#" :class="{ 'active': actTab === 'news' }" @click.prevent="switchTab('news')">道信动态</a> </div>
          <div class="ml-30"><a href="#" :class="{ 'active': actTab === 'media' }"
              @click.prevent="switchTab('media')">媒体报道</a></div>
          <!-- <div class="text-uppercase ml-30"><a href="#">more</a></div> -->
        </div>
      </div>
      <div v-if="actTab === 'news'" class="tab-content">
        <div class="d-flex space-between  align-center pd20 newBlock" v-for="(items,kx) in source.slice(1,4)" :key="kx" @click="ops(items)">

          <div class="d-flex align-center">
            <img :src="items.img" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">{{items.titele}}</h3>
              <p class="fs-14 " style="margin-top: 10px;">{{items.text}}</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div>


        <!-- <div class="d-flex space-between  align-center pd20 newBlock">

          <div class="d-flex align-center">
            <img :src="rc33" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">国家电投中电大别山新能源基地为老区送“阳光收益”</h3>
              <p class="fs-14 " style="margin-top: 10px;">今后，伊藤忠商事是GRD提供机械学习框架“ReNom活用，该公司和国内·海外
                制适会额信息通信地方，即使对方的开发了几十个的付款了估计圣诞快乐法国领导反馈给解决发噶的就</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div>




        <div class="d-flex space-between  align-center pd20 newBlock">

          <div class="d-flex align-center">
            <img :src="rc22" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">中小物流企业集约化发展的三种联盟模式</h3>
              <p class="fs-14 " style="margin-top: 10px;">今后，伊藤忠商事是GRD提供机械学习框架“ReNom活用，该公司和国内·海外
                制适会额信息通信地方，即使对方的开发了几十个的付款了估计圣诞快乐法国领导反馈给解决发噶的就</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div>

        <div class="d-flex space-between  align-center pd20 newBlock">

          <div class="d-flex align-center">
            <img :src="rc3" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">四方光电嘉善园区产能利用率保持较高水平</h3>
              <p class="fs-14 " style="margin-top: 10px;">今后，伊藤忠商事是GRD提供机械学习框架“ReNom活用，该公司和国内·海外
                制适会额信息通信地方，即使对方的开发了几十个的付款了估计圣诞快乐法国领导反馈给解决发噶的就</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div>

        <div class="d-flex space-between  align-center pd20 newBlock" style="margin-bottom: 100px;">

          <div class="d-flex align-center">
            <img :src="rc3" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">中小物流企业集约化发展的三种联盟模式</h3>
              <p class="fs-14 " style="margin-top: 10px;">今后，伊藤忠商事是GRD提供机械学习框架“ReNom活用，该公司和国内·海外
                制适会额信息通信地方，即使对方的开发了几十个的付款了估计圣诞快乐法国领导反馈给解决发噶的就</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div> -->

      </div>
      <!--  -->
      <div v-if="actTab === 'media'" class="tab-content">
        <div class="d-flex space-between  align-center pd20 newBlock" v-for="(items,kx) in source.slice(5,8)" :key="kx" @click="ops(items)">

          <div class="d-flex align-center">
            <img :src="items.img" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">{{items.titele}}</h3>
              <p class="fs-14 " style="margin-top: 10px;">{{items.text}}</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div>


        <!-- <div class="d-flex space-between  align-center pd20 newBlock">

          <div class="d-flex align-center">
            <img :src="rc33" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">三星电子、SK海力士目标在2026年上半年完成HBM4E的研发</h3>
              <p class="fs-14 " style="margin-top: 10px;">三星电子和SK海力士已设定目标，力争在2026年上半年完成HBM4E的研发。因
此双方正在加速研发，争取在明年下半年完成质量验证。乐法国领导反馈给解决发噶的就</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div>




        <div class="d-flex space-between  align-center pd20 newBlock">

          <div class="d-flex align-center">
            <img :src="rc11" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">中小物流企业集约化发展的三种联盟模式</h3>
              <p class="fs-14 " style="margin-top: 10px;">公司注意到通信及数据中心领域市场需求持续回暖，部分高端PCB产品价格呈现
回升态势。圣诞快乐法国领导反馈给解决发噶的就</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div>

        <div class="d-flex space-between  align-center pd20 newBlock">

          <div class="d-flex align-center">
            <img :src="rc11" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">部分高端PCB产品价格呈现回升态
</h3>
              <p class="fs-14 " style="margin-top: 10px;">公司注意到通信及数据中心领域市场需求持续回暖，部分高端PCB产品价格呈现
回升态势。了估计圣诞快乐法国领导反馈给解决发噶的就</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div>

        <div class="d-flex space-between  align-center pd20 newBlock" style="margin-bottom: 100px;">

          <div class="d-flex align-center">
            <img :src="rc11" alt="" style="margin-right:40px;">
            <div class="text-left">
              <h3 class="color-1">三星电子和SK海力士已设定目标，力争在2026年上半年完成HBM4E的研发</h3>
              <p class="fs-14 " style="margin-top: 10px;">今后，伊藤忠商事是GRD提供机械学习框架“ReNom活用，该公司和国内·海外
                制适会额信息通信地方，即使对方的开发了几十个的付款了估计圣诞快乐法国领导反馈给解决发噶的就</p>
            </div>
          </div>

          <div style="width: 250px;text-align: center;"> <span class="mores">MORE</span> </div>
        </div> -->


      </div>
      <!--  -->






    </div>


    <IndxFoot></IndxFoot>

  </div>
</template>

<script>
import IndxHeads from '@/components/IndxHeads.vue'
import IndxFoot from '@/components/IndxFoot.vue'
import rc3 from "@/images/new1.png"
import rc22 from "@/images/new2.png"
import rc33 from "@/images/new3.png"
import rc11 from "@/images/new11.png"
export default {
  name: 'HomePage',
  components: {
    IndxHeads,
    IndxFoot
  },
  data() {
    return {source: [{
        titele: "新矿产资源法的十大亮点",img:rc3, date: '02-08',text:'矿产资源是工业的粮食和血液，是经济社会发展的重要物质基础。随着工业化、城镇化的快速推进，我国对矿产资源的需求和消耗日益增大。同时，随着绿色低碳革命在全球的推进', url:'https://www.gov.cn/lianbo/bumen/202411/content_6986009.htm'
      },
      { titele: '新修订的《中华人民共和国矿产资源法》 ', img:rc22, text:'(1986年3月19日第六届全国人民代表大会常务委员会第十五次会议通过  根据1996年8月29日第八届全国人民代表大会常务委员会第二十一次会议《关于修改〈中华人民共和国矿产资源法〉的决定》',date: '05-09' ,url:'http://www.gsht.gov.cn/zfxxgk/bmxzxxgk/xzxxgk/htssyxrmzf/fdzdgknr/YJGL/art/2025/art_a0971c70db614319b7f3c5b00e68c2d2.html'},
      { titele: '新能源2035年目标：风光装机容量迈向36亿千瓦 ',img:rc33,  text:'截至2024年底，全国风电、光伏装机容量已达13.5亿千瓦，提前6年完成《巴黎协定》设定的2030年目标。而2035年36亿千瓦的装机容量，相当于在现有基础上再造两个半“中国电网”，其规模超过美国、欧盟、印度三大经济体总和。',date: '06-29',url:'https://xueqiu.com/1438272693/354635779' },
      { titele: '“十五五”规划（2026-2030年）核心内容解析 ',img:rc11, text:'“十五五”规划是我国迈向2035年基本实现社会主义现代化目标的关键五年规划，其核心内容围绕“高质量发展”主线，聚焦“科技自立自强”“产业升级”“内需扩大”“安全保障”四大维度，旨在通过系统性部署破解发展难题、增强发展动力、厚植发展优势。',date: '06-19',url:"http://www.360doc6.net/wxarticlenew/1163849574.html"},
      { titele: 'A股三大股指尾盘下跌，摩尔线程猛涨28%市值破4400亿，加密货币全线杀跌15万人爆仓',img:rc3,  text:'12月11日午后，亚太股市呈现“先扬后抑”的剧烈反转，截至收盘日韩股市集体收跌，A股三大股指尾盘也加速下跌，创业板指、深证成指均跌超1%，沪指跌0.7%，全市场超4300只个股下跌。泛消费、房地产、纺织服装、食品饮料等方向跌幅居前。', date: '07-26',url:'https://www.21jingji.com/article/20251211/herald/29973b6d31bfbc3b90ecec1bd09f43de.html' },
      { titele: '兴业证券：氢能市场前景和生态价值广阔 推荐绿色甲醇生产环节   ', img:rc22, text:'兴业证券发布研报称，氢能在十五五期间走向规模化的规划更加清晰。同时展现出广阔的市场前景和生态价值，但是具备经济性、可持续性的商业模式仍是',date: '08-22',url:"https://finance.sina.com.cn/stock/hkstock/ggscyd/2025-12-05/doc-infzttzy9885006.shtml" },
      { titele: 'OpenAI会是第一个倒闭的AI独角兽吗？ ',img:rc11, text:'11月20日，Gemini3推出两天后，在被称为“硅谷投资人春晚”的Cerebral Valley AI峰会上，OpenAI就被选成了“第二大可能倒闭的AI独角兽”。', date: '08-25',url:"https://finance.sina.com.cn/tech/internet/2025-12-07/doc-infzxvsr3004349.shtml" },
      { titele: '好生意的故事，给投资带来的启发：', img:rc33, text:'一位茶商，祖上就经营云南的古树生普，他家的恒温存茶的库房，一进去，满屋茶砖茶饼，茶香四溢。现在库房里还存有上世纪60年代的普洱茶，而这些普洱茶当年的收购价1斤竟然不到1元钱',date: '09-28',url:'https://xueqiu.com/1176935028/360177531' },
      ],
      rc3: rc3,
      rc22: rc22,
      rc33: rc33,
      rc11: rc11,
      actTab: 'news'
    }
  },
  mounted() {

  },
  beforeUnmount() {

  },
  methods: {ops(tes){
      window.open(tes.url,'_blanks')
    },
    switchTab(tab) {
      this.actTab = tab;
    }
  }
}
</script>

<style scoped>
.moreCom a.active {
  color: #0547c2;
  font-weight: bold;
}


.newBg {
  background: url(/src/images/xinwbg.png) no-repeat;
  background-size: cover;
  width: 100%;
  height: 500px;

}

.mores {
  padding: 4px 36px;
  color: #555555;
  border: 1px solid #979797;
  border-radius: 50px;
}

.newBlock {
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
  margin-bottom: 30px;

}

.moreCom a {
  text-decoration: none;
  color: #555555;
}

.moreCom a:hover {
  color: #0547c2;
}


.newBlock:hover .mores {
  background: #0547c2;
  color: #ffffff;
  border: 1px solid #0547c2;
  cursor: pointer;

}

.newBlock:hover {
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.23);
  cursor: pointer;
}
</style>